// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"2f8076b3","200":"1928fa0f","265":"a7e96bce","307":"8ce4787a"}[chunkId] + ".chunk.js";
};